import Swal from "sweetalert2";
import ReloadIcon from 'mdi-react/ReloadIcon';
import React, { useState, useEffect } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import { Col, Container, Row } from 'react-bootstrap';
import withReactContent from "sweetalert2-react-content";
import { Redirect, Route, Switch } from 'react-router-dom';
import FilesList from '@/containers/Files/components/FilesList';
import UploadFiles from '@/containers/Files/components/UploadFiles';

const Files = () => {
    const [usage, setUsage] = useState();
    const [reload, setReload] = useState(true);

    useEffect(() => {
        if (reload === false) return;

        AdminInterface.instance.getFilesUsage().then((reponse) => {
            let total_usage = reponse.data['total_usage_bytes']
            setUsage(Math.round((total_usage / (1024 * 1024)) * 10) / 10);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response.data?.detail,
            });
        }).finally(() => {
            setReload(false);
        })
      }, [reload]);

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Files Management</h3>
                    <h3 className="page-subhead subhead">Manage workspace files</h3>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}>
                        <strong>Storage Usage:</strong>&nbsp;{usage} MB
                        <span style={{ cursor: 'pointer', marginLeft: 10, display: 'flex', alignItems: 'center', marginBottom: '2px' }}
                              onClick={() => setReload(true)}
                              title="Reload Usage">
                                <ReloadIcon size={15} />
                        </span>
                    </div>
                    <Switch>
                        <Route path="/assets/files/list" component={FilesList} />
                        <Route path="/assets/files/upload" component={UploadFiles} />
                        <Redirect from="/assets/files" to="/assets/files/list" />
                    </Switch>
                </Col>
            </Row>
        </Container>
    );
};

export default Files;